import React, { useState } from "react";
import { Modal, Button, Form, Input, Typography, Space } from "antd";
import { MailOutlined, LockOutlined, NumberOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { toast } from "../toasts/toastStore";
import {
  actionForgotPassword,
  actionValidateResetCode,
  actionResetPassword,
} from "../../redux/actions/login/login";

const { Title, Text } = Typography;

function ModalOlvidar({ show, setShow }) {
  const dispatch = useDispatch();
  const [step, setStep] = useState("email"); // email -> code -> password
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const reset = () => {
    setStep("email");
    setEmail("");
    setCode("");
    form.resetFields();
  };

  const close = () => {
    if (loading) return;
    setShow(false);
    reset();
  };

  const submitEmail = async () => {
    try {
      const { email: value } = await form.validateFields(["email"]);
      setLoading(true);
      dispatch(
        actionForgotPassword(
          value,
          () => {
            setLoading(false);
            setEmail(value);
            setStep("code");
            toast.info("Si el correo esta registrado, te enviamos un codigo.");
          },
          (msg) => {
            setLoading(false);
            toast.error(msg || "No se pudo enviar el codigo");
          }
        )
      );
    } catch {}
  };

  const submitCode = async () => {
    try {
      const { code: value } = await form.validateFields(["code"]);
      setLoading(true);
      dispatch(
        actionValidateResetCode(
          email,
          value,
          () => {
            setLoading(false);
            setCode(value);
            setStep("password");
          },
          (msg) => {
            setLoading(false);
            toast.error(msg || "Codigo invalido o expirado");
          }
        )
      );
    } catch {}
  };

  const submitPassword = async () => {
    try {
      const { new_password } = await form.validateFields(["new_password"]);
      setLoading(true);
      dispatch(
        actionResetPassword(
          { email, code, new_password },
          () => {
            setLoading(false);
            toast.success("Contrasena actualizada. Ya puedes iniciar sesion.");
            close();
          },
          (msg) => {
            setLoading(false);
            toast.error(msg || "No se pudo actualizar la contrasena");
          }
        )
      );
    } catch {}
  };

  return (
    <Modal
      open={show}
      centered
      closable={!loading}
      maskClosable={!loading}
      onCancel={close}
      width={480}
      footer={null}
    >
      <div style={{ padding: "8px 4px 16px" }}>
        <Title level={4} style={{ marginBottom: 4 }}>
          Recuperar contrasena
        </Title>
        <Text type="secondary">
          {step === "email" && "Ingresa el correo de recuperacion de tu cuenta."}
          {step === "code" && "Ingresa el codigo que enviamos a tu correo."}
          {step === "password" && "Define tu nueva contrasena."}
        </Text>

        <Form form={form} layout="vertical" requiredMark="optional" style={{ marginTop: 18 }}>
          {step === "email" && (
            <Form.Item
              label="Correo de recuperacion"
              name="email"
              rules={[
                { required: true, message: "El correo es obligatorio." },
                { type: "email", message: "Escribe un correo valido." },
              ]}
            >
              <Input prefix={<MailOutlined />} size="large" autoFocus onPressEnter={submitEmail} />
            </Form.Item>
          )}

          {step === "code" && (
            <Form.Item
              label="Codigo de verificacion"
              name="code"
              rules={[{ required: true, message: "El codigo es obligatorio." }]}
            >
              <Input prefix={<NumberOutlined />} size="large" maxLength={6} autoFocus onPressEnter={submitCode} />
            </Form.Item>
          )}

          {step === "password" && (
            <Form.Item
              label="Nueva contrasena"
              name="new_password"
              rules={[
                { required: true, message: "La contrasena es obligatoria." },
                { min: 6, message: "Minimo 6 caracteres." },
              ]}
            >
              <Input.Password prefix={<LockOutlined />} size="large" autoFocus onPressEnter={submitPassword} />
            </Form.Item>
          )}

          <Space style={{ width: "100%", justifyContent: "flex-end", marginTop: 8 }}>
            <Button onClick={close} disabled={loading}>
              Cancelar
            </Button>
            <Button
              type="primary"
              loading={loading}
              onClick={
                step === "email" ? submitEmail : step === "code" ? submitCode : submitPassword
              }
              style={{ background: "#f90336", borderColor: "#f90336" }}
            >
              {step === "password" ? "Guardar" : "Continuar"}
            </Button>
          </Space>
        </Form>
      </div>
    </Modal>
  );
}

export default ModalOlvidar;
